import Vue from 'vue'
import { initialState } from './state'
import store from '../index.js'

export default {
  isLoading,
  doneLoading,
  openOrderType,
  closeOrderType,
  updateOrderForm,
  updateOrderTypeForm,
  updateSelectedUserOverrides,
  updateSelectedCourseOverrides,
  updateSelectedAffiliateOverrides,
  clearSelectedUserOverrides,
  clearSelectedCourseOverrides,
  clearSelectedAffiliateOverrides,
  addShippingMethod,
  removeShippingMethod,
  addUserOverride,
  removeUserOverride,
  addOverrideShippingMethod,
  removeOverrideShippingMethod,
  setList,
  setOrderForm,
  setOrderTypeForm,
  setOrderTypes,
  setOrderTypeOverrides,
  clearOrderForm,
  clearOrderTypeForm,
  openOrderManagementModal,
  closeOrderManagementModal,
  updateSelectedTab,
  updateItemFromType,
  updateItemShippingTotal,
  updateItemShippingMethod,
  updateItemShippingMethodOptions,
  setPaymentType,
  addPendingOrderItem,
  paymentModalOpenState,
  detailsModalOpen,
  removeOrderItem,
  resetState,
  updateAdminOverrideAmount,
  autocompleteOrderAddressUpdate,
  setCustomerInformation,
  clearCurrentCustomerProfile,
  setExistingOrNew,
  setProcessing,
  preAdminBypass,
  setLoadOrderTypes,
  updatePaymentCallback,
  setSearchOrderTypes,
  setSearchUserHelper,
  clearSearchFields,
  setSelectedSearchUser,
  handleAuthorizeBypassResponse,
  selectOrderItemAffiliate,
  selectAccountCreditsAffiliate
}

function selectAccountCreditsAffiliate(state, affiliate){
  state.pendingPayment.accountCredits.affiliate = affiliate
}

function selectOrderItemAffiliate(state, { itemIndex, affiliate }){
  state.pendingPayment.items[itemIndex].affiliate = affiliate
}

function handleAuthorizeBypassResponse(state, data){  
  state.pendingPayment.adminBypass.madeCall = true
  console.log(data)
  if(data !== undefined){
    state.pendingPayment.adminBypass.authorized = data
    state.pendingPayment.adminBypass.password = ''
    if(data == true){
      state.pendingPayment.adminBypass.active = false
      state.pendingPayment.adminBypass.overrideTotal = _.sumBy(state.pendingPayment.items, (item) => {
          return parseFloat(parseFloat(item.price * item.quantity + item.shippingTotal).toFixed(2))
      }).toFixed(2)
      let callback = state.pendingPayment.adminBypass.callback
      if(callback) callback()
    }
  }
  state.pendingPayment.adminBypass.authorizing = false
}

function preAdminBypass(state, { active, callback = null }){
  state.pendingPayment.adminBypass.active = active
  if(callback){
    console.log(callback)
      state.pendingPayment.adminBypass.callback = () => {
      callback()
      state.pendingPayment.adminBypass.callback = null
    }
  }
  state.pendingPayment.adminBypass.for = (active) ? _.clone(state.pendingPayment.paymentType) : null
}

function setSearchUserHelper(state, payload){
  state.userHelper = payload
}

function setSelectedSearchUser(state, payload){
    state.searchFields.USER_ID = (payload && payload.item) ? payload.item.USER_ID : null
}

function clearSearchFields(state, payload){
  state.searchFields = _.cloneDeep(initialState.searchFields)
}

function updatePaymentCallback(state, payload){
  state.afterProcessCallback = payload
}

function setLoadOrderTypes(state, payload){
  state.loadOrderTypes = payload
}

function autocompleteOrderAddressUpdate(state, {place, field, stateOptions}){
  let a = place.address_components
  
  state.pendingPayment[field].address1 = `${addrPart('street_number',a).long_name || ''} ${addrPart('route',a).long_name || ''}`
  state.pendingPayment[field].city = `${addrPart('locality',a).long_name || addrPart('sublocality',a).long_name || ''}`
  state.pendingPayment[field].county = `${addrPart('administrative_area_level_2',a).long_name.replace(" County","") || ''}`
  state.pendingPayment[field].zip = `${addrPart('postal_code',a).short_name || ''}`
  
  let foundState = _.find(stateOptions,{label: addrPart('administrative_area_level_1',a).short_name.toUpperCase()})
  if(foundState && foundState.value){
    state.pendingPayment[field].state = foundState.value
  }
}

function addrPart(type,address){
  return _.find(address,{types:[type]}) || {long_name:null,short_name:null}
}

function setProcessing(state, payload){
  state.pendingPayment.processing = payload
}

function setExistingOrNew(state, payload){
  state.pendingPayment.existingOrNew = payload
}

function setCustomerInformation(state, payload){
  let { user, billingAddress, mailingAddress, customerProfiles } = payload
  state.pendingPayment.customer.USER_ID = user.USER_ID
  state.pendingPayment.customer.user = user
  if(billingAddress){
    state.pendingPayment.billingAddress = {
      address1: billingAddress.ADDRESS_1,
      address2: billingAddress.ADDRESS_2,
      city: billingAddress.CITY,
      state: billingAddress.LK_STATE_ID,
      zip: billingAddress.ZIP_CODE,
      county: billingAddress.COUNTY
    }
  }
  else{
    state.pendingPayment.billingAddress = _.cloneDeep(initialState.pendingPayment.billingAddress)
  }
  if(mailingAddress){
    state.pendingPayment.mailingAddress = {
      address1: mailingAddress.ADDRESS_1,
      address2: mailingAddress.ADDRESS_2,
      city: mailingAddress.CITY,
      state: mailingAddress.LK_STATE_ID,
      zip: mailingAddress.ZIP_CODE,
      county: mailingAddress.COUNTY
    }
  }
  else{
    state.pendingPayment.mailingAddress = _.cloneDeep(initialState.pendingPayment.mailingAddress)
  }

  if(mailingAddress && billingAddress){
    let addressesAreSameID =  mailingAddress.ADDRESS_ID === billingAddress.ADDRESS_ID
    state.pendingPayment.sameAsBilling = addressesAreSameID
  }
  
  state.pendingPayment.customer.paymentProfiles = customerProfiles || []
  // if(state.pendingPayment.customer.paymentProfiles.length > 0){
  //   state.pendingPayment.customer.selectedPaymentProfile = state.pendingPayment.customer.paymentProfiles[0].value
  // }
  state.pendingPayment.existingOrNew = null 
  state.pendingPayment.paymentType = null
  state.pendingPayment.adminBypass = _.cloneDeep(initialState.pendingPayment.adminBypass)
  state.pendingPayment.cc = _.cloneDeep(initialState.pendingPayment.cc)
}

function clearCurrentCustomerProfile(state, payload){
  state.pendingPayment.customer = _.cloneDeep(initialState.pendingPayment.customer)
  state.pendingPayment.billingAddress = _.cloneDeep(initialState.pendingPayment.billingAddress)
  state.pendingPayment.mailingAddress = _.cloneDeep(initialState.pendingPayment.mailingAddress)
  state.pendingPayment.customer.paymentProfiles = _.cloneDeep(initialState.pendingPayment.paymentProfiles)
  state.pendingPayment.sameAsBilling = _.cloneDeep(initialState.pendingPayment.sameAsBilling)
}

function isLoading (state) {
  state.loadingData = true
}

function doneLoading (state) {
  state.loadingData = false
}

function openOrderType (state) {
  state.orderTypeModal.open = true
}

function closeOrderType (state) {
  state.orderTypeModal.open = false
}

function updateOrderForm (state, { field, value }) {
  console.log('field', field)
  console.log('value', value)
  Object.assign(state.orderForm, {
    [field]: value
  })
}

function updateOrderTypeForm (state, { field, value }) {
  console.log('field', field)
  console.log('value', value)
  Object.assign(state.orderTypeForm, {
    [field]: value
  })
}

function updateSelectedUserOverrides (state, selectedUserOverrides) {
  state.selectedUserOverrides = [...selectedUserOverrides]
}

function updateSelectedCourseOverrides (state, selectedCourseOverrides) {
  state.selectedCourseOverrides = [...selectedCourseOverrides]
}

function updateSelectedAffiliateOverrides (state, selectedAffiliateOverrides) {
  state.selectedAffiliateOverrides = [...selectedAffiliateOverrides]
}

function clearSelectedUserOverrides (state) {
  state.selectedUserOverrides = state.selectedUserOverrides.splice(state.selectedUserOverrides.length)
}

function clearSelectedCourseOverrides (state) {
  state.selectedCourseOverrides = state.selectedCourseOverrides.splice(state.selectedCourseOverrides.length)
}

function clearSelectedAffiliateOverrides (state) {
  state.selectedAffiliateOverrides = state.selectedAffiliateOverrides.splice(state.selectedAffiliateOverrides.length)
}

function addShippingMethod (state) {
  state.orderTypeForm.SHIPPING_METHODS.push({ ORDER_TYPE_ID: state.orderTypeForm.ORDER_TYPE_ID, LK_SHIPPING_TYPE_ID: '', PRICE: '', ITEM_LIMIT: null, IS_DEFAULT: 0 })
}

function removeShippingMethod (state, index) {
  state.orderTypeForm.SHIPPING_METHODS.splice(index, 1)
}

function addUserOverride (state, user) {
  state.userOverrides.push(user)
}

function removeUserOverride (state, index) {
  state.userOverrides.splice(index, 1)
}

function addOverrideShippingMethod (state, options) {
  state.orderTypeOverrides[options.overrideIndex].SHIPPING_METHODS.push({ LK_SHIPPING_TYPE_ID: '', PRICE: '', ITEM_LIMIT: null, IS_DEFAULT: 0 })
}

function removeOverrideShippingMethod (state, options) {
  state.orderTypeOverrides[options.overrideIndex].SHIPPING_METHODS.splice(options.shippingMethodIndex, 1)
}

function setList (state, { orders }) {
  state.list = orders
}

function setOrderForm (state, { selectedOrder }) {
  _.each(selectedOrder, (value, key) => {
    state.orderForm[key] = value
  })
}

function setOrderTypeForm (state, { selectedOrderType }) {
  _.each(selectedOrderType, (value, key) => {
    state.orderTypeForm[key] = value
  })
}

function setOrderTypes (state, orderTypes) {
  if(store.state.classes.processingClass){
    return state.orderTypes = orderTypes
  }
  if(!state.pendingPayment.wasPayLater){
    state.orderTypes = _.filter(state.orderTypes, ot => { return !ot.removeOnNewOrder })
  }
  let newAndOldOrderTypes = [ ...orderTypes, ..._.cloneDeep(state.orderTypes) ]
  state.orderTypes = _.uniqBy(newAndOldOrderTypes, 'ORDER_TYPE_ID')
}

function setSearchOrderTypes (state, orderTypes) {
  state.searchOrderTypes = orderTypes
}


function setOrderTypeOverrides (state, orderTypeOverrides) {
  state.orderTypeOverrides = orderTypeOverrides
}

function clearOrderForm (state) {
  _.each(state.orderForm, (value, key) => {
    state.orderForm[key] = initialState.orderForm[key]
  })
}

function clearOrderTypeForm (state) {
  _.each(state.orderTypeForm, (value, key) => {
    state.orderTypeForm[key] = initialState.orderTypeForm[key]
  })
}

function openOrderManagementModal (state) {
  state.orderManagementModal.open = true
}

function closeOrderManagementModal (state) {
  state.orderManagementModal.open = false
  state.orderManagementModal.selectedTab = 'details'
}

function updateSelectedTab (state, selectedTab) {
  state.orderManagementModal.selectedTab = selectedTab
}

function updateItemShippingTotal (state, { itemIndex }) {
  let storeToChange = state.pendingPayment.items[itemIndex]
  let { shippingMethodObj } = storeToChange
  if (shippingMethodObj) {
    storeToChange.shippingTotal = (shippingMethodObj.ITEM_LIMIT) ? (Math.ceil(storeToChange.quantity / shippingMethodObj.ITEM_LIMIT) * shippingMethodObj.PRICE) : shippingMethodObj.PRICE
  }
}

function updateItemShippingMethod (state, { itemIndex, shippingMethod }) {
  let storeToChange = state.pendingPayment.items[itemIndex]

  if(!shippingMethod){
    storeToChange.shippingMethod = null
    storeToChange.shippingMethodObj = null
    storeToChange.shippingTotal = 0
    return
  }

  const shippingMethodObj = _.find(storeToChange.orderTypeObj.SHIPPING_METHODS, { SHIPPING_METHOD_ID: shippingMethod })
  if(shippingMethodObj){
    storeToChange.shippingMethod = shippingMethod
    storeToChange.shippingMethodObj = shippingMethodObj
    storeToChange.shippingTotal = (shippingMethodObj.ITEM_LIMIT) ? Math.ceil(storeToChange.quantity / shippingMethodObj.ITEM_LIMIT) * shippingMethodObj.PRICE : shippingMethodObj.PRICE
  }
}

function updateItemShippingMethodOptions (state, { itemIndex, orderTypeId }) {
  let foundOrderType = state.orderTypes[state.orderTypes.findIndex(orderType => orderType.ORDER_TYPE_ID === orderTypeId)]
  
  if(foundOrderType){
    state.pendingPayment.items[itemIndex].shippingMethodOptions = foundOrderType
      .SHIPPING_METHODS.map(shippingMethod => {
        let label = _.capitalize(shippingMethod.SHIPPING_TYPE.SHIPPING_TYPE) + ' - $' + shippingMethod.PRICE
        if (shippingMethod.ITEM_LIMIT) {
          label += '/' + shippingMethod.ITEM_LIMIT + ' items'
        }
        return { label, value: Number.parseInt(shippingMethod.SHIPPING_METHOD_ID), price: shippingMethod.PRICE }
      })
  }

  // Set Default Shipping Method
  let foundShippingIndex = state.orderTypes[state.orderTypes.findIndex(orderType => orderType.ORDER_TYPE_ID === orderTypeId)]
  if(foundShippingIndex){
    const defaultShippingMethodIndex = foundShippingIndex.SHIPPING_METHODS.findIndex(shippingMethod => shippingMethod.IS_DEFAULT)
    if(foundOrderType && foundOrderType.SHIPPING_METHODS && foundOrderType.SHIPPING_METHODS.length > 0){
      if (defaultShippingMethodIndex !== -1) {
        state.pendingPayment.items[itemIndex].shippingMethod = foundOrderType.SHIPPING_METHODS[defaultShippingMethodIndex].SHIPPING_METHOD_ID
      } else {
        state.pendingPayment.items[itemIndex].shippingMethod = foundOrderType.SHIPPING_METHODS[0].SHIPPING_METHOD_ID
      }
    }
  }

}

function updateItemFromType (state, {itemIndex, orderType, detail, quantity, shippingMethod}) {
  let storeToChange = (detail) ? state.orderDetails : state.pendingPayment
  storeToChange.items[itemIndex].orderType = orderType
  // Account Credits
  if(orderType === 76){
    storeToChange.items[itemIndex].affiliate = null
  }
  else{
    storeToChange.items[itemIndex].affiliate = undefined
  }
  const shippingMethodObj = storeToChange.items[itemIndex].shippingMethodObj
  if (quantity) {
    storeToChange.items[itemIndex].quantity = quantity
    
    // storeToChange.items[itemIndex].shippingTotal = (shippingMethodObj.ITEM_LIMIT) ? Math.ceil(storeToChange.quantity / shippingMethodObj.ITEM_LIMIT) * shippingMethodObj.PRICE : shippingMethodObj.PRICE
  }
  if (shippingMethod) storeToChange.items[itemIndex].shippingMethod = shippingMethod

  const orderTypeObj = _.find(state.orderTypes, { ORDER_TYPE_ID: orderType })
  storeToChange.items[itemIndex].orderTypeObj = orderTypeObj
  const orderTypeOverride = _.find(state.orderTypeOverrides, {ORDER_TYPE_ID: orderType})

  if (orderTypeOverride) {
    storeToChange.items[itemIndex].price = orderTypeOverride.PRICE
    storeToChange.items[itemIndex].min = orderTypeOverride.MIN_AMOUNT
    storeToChange.items[itemIndex].max = orderTypeOverride.MAX_AMOUNT
  } else if (orderTypeObj) {
    storeToChange.items[itemIndex].price = orderTypeObj.PRICE
    storeToChange.items[itemIndex].min = orderTypeObj.MIN_AMOUNT
    storeToChange.items[itemIndex].max = orderTypeObj.MAX_AMOUNT
  } else {
    storeToChange.items[itemIndex].price = 0
    storeToChange.items[itemIndex].min = 0
    storeToChange.items[itemIndex].max = 999
  }
  
  const min = (storeToChange.items[itemIndex].min || 1)
  const max = (storeToChange.items[itemIndex].max || 99)
  
  if (storeToChange.items[itemIndex].quantity > max) {
    storeToChange.items[itemIndex].quantity = max
  }
  if (storeToChange.items[itemIndex].quantity < min) {
    storeToChange.items[itemIndex].quantity = min
  }

  // let itemShipping = storeToChange.items[itemIndex]
  // let shippingMethods = itemShipping.orderTypeObj.SHIPPING_METHODS
  // let shippingMethodObj = _.find(shippingMethods, { SHIPPING_METHOD_ID: itemShipping.shippingMethod })
  // itemShipping.shippingTotal = (shippingMethodObj.ITEM_LIMIT) ? Math.ceil(itemShipping.quantity / shippingMethodObj.ITEM_LIMIT) * shippingMethodObj.PRICE : shippingMethodObj.PRICE

}

function updateAdminOverrideAmount (state, val){
  state.pendingPayment.adminBypass.overrideTotal = (val != undefined) ? parseFloat(val).toFixed(2) : 0
}

function setPaymentType (state, type) {
  state.pendingPayment.paymentType = (type || null)
  if(type != 'ACH Payment' && type != 'Money Order' && type != 'Account Credits') state.pendingPayment.adminBypass = _.cloneDeep(initialState.pendingPayment.adminBypass)
  state.pendingPayment.cc = _.cloneDeep(initialState.pendingPayment.cc)
  if(!type){
    state.pendingPayment.adminBypass.authorized = false
    state.pendingPayment.adminBypass.authorizing = false
    state.pendingPayment.adminBypass.madeCall = false
    state.pendingPayment.adminBypass.overrideTotal = 0
    state.pendingPayment.customer.selectedPaymentProfile = null
  }
  let paymentTypeId
  switch(type){
    case "Admin Bypass":
      paymentTypeId = 1
      break
    case "Credit Card":
      paymentTypeId = 2
      break
    case "Paypal":
      paymentTypeId = 3
      break
  }
  state.pendingPayment.paymentTypeId = paymentTypeId
}

function addPendingOrderItem (state) {
  state.pendingPayment.items.push(state.newItemState())
}

function paymentModalOpenState (state, open) {
  state.processPaymentModalOpen = open
  state.pendingPayment.adminBypass.authorized = false
  state.pendingPayment.adminBypass.authorizing = false
  state.pendingPayment.adminBypass.madeCall = false
  state.pendingPayment.adminBypass.overrideTotal = 0
  state.pendingPayment.accountCredits.affiliate = null
  state.pendingPayment.moneyOrder.notes = ''
  state.pendingPayment.ach.account = ''
  state.pendingPayment.ach.routing = ''
  state.pendingPayment.ach.name = ''
  state.pendingPayment.wasPayLater = false
  state.pendingPayment.processing = false
  state.pendingPayment.ORDER_ID = undefined

  state.pendingPayment.paymentType = null
  state.pendingPayment.canAdd = true
  state.pendingPayment.closeModalOnPaymentComplete = true
  state.pendingPayment.items = []

  state.pendingPayment.sameAsBilling = true

  _.each(state.pendingPayment.billingAddress, (value, key) => {
    state.pendingPayment.billingAddress[key] = initialState.pendingPayment.billingAddress[key]
  })
  
  _.each(state.pendingPayment.mailingAddress, (value, key) => {
    state.pendingPayment.mailingAddress[key] = initialState.pendingPayment.mailingAddress[key]
  })

  if(!open){
    state.afterProcessCallback = null
  }
}

function detailsModalOpen (state, open){
  state.detailsModalOpenState = open
}

function removeOrderItem (state, itemIndex) {
  console.log(itemIndex)
  state.pendingPayment.items.splice(itemIndex,1)
}

function resetState (state) {
  // _.each(state, (value, key) => {
  //   state[key] = initialState[key]
  // })
  state = { ...initialState }
}
